module.exports = __webpack_public_path__ + "static/workbc-header-logo-9fb33274161ff9dae7810bef0b3ec0df.svg";